import e from "@dialpad/dialtone-tokens/layered/themes/tokens-126-colors.css?inline";
//#region themes/126.js
var t = { brand: {
	css: e,
	name: "126"
} };
//#endregion
export { t as default };
